<div class="product-request-list">
  <lp-product-request-list-header
    [title]="'components.lpProductRequest.labels.productRequestList' | translate"
    (add)="startCreate.emit()"
  ></lp-product-request-list-header>

  <tui-scrollbar>
    <div class="product-request-list__content">
      <lp-product-request-list-item
        *ngFor="let item of productRequests$ | async"
        [item]="item"
        (onSelectItem)="onSelectItem.emit(item.id)"
      ></lp-product-request-list-item>
    </div>
  </tui-scrollbar>
</div>
